import React from 'react';
import Skill from '../Skill';
import { data } from '../../skillsData';

const Skills = () => {
    return (
        <section className='px-3 pt-10 md:p-5 mb-12'>
            <h1 className='text-3xl font-bold my-3 text-gray-800'>My Skills</h1>
            <p className='text-sm mb-3'>I am a front end web developer specialized in HTML5, CSS3, Bootstrap, Tailwind, MaterialUI, JavaScript, React, Redux, Firebase Auth, Context API etc. I also have basic knowledge of NodeJS, Express and MongoDB</p>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-3'>
                {
                    data.map(skill => <Skill key={skill.title} skill={skill} />)
                }
            </div>
        </section>
    )
}

export default Skills;
